import { inject, observer }               from "mobx-react";
import * as React                         from "react";
import ConfirmationModal                  from "../../../Views/Components/Modal/ConfirmationModal";
import ModalService                       from "../../../Service/ModalService";
import { Container }                      from "typedi";
import { ModalStore }                     from "../../../Store/ModalStore";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { PromotionStore }                 from "../../../Store/PromotionStore";
import { Promotion }                      from "../../../Models/Promotion/Promotion";

interface IDeleteGalleryViewModelProps extends WithNamespaces {
    ModalStore?: ModalStore;
    PromotionStore?: PromotionStore;
    promotion: Promotion;
}

@inject(ModalStore.NAME_STORE, PromotionStore.NAME_STORE)
@observer
class DeletePromotionViewModel extends React.Component<IDeleteGalleryViewModelProps, {}> {
    private readonly modalService: ModalService;

    constructor(props: IDeleteGalleryViewModelProps) {
        super(props);

        this.modalService = Container.get(ModalService);
    }

    get promotionStore(): PromotionStore {
        return this.props.PromotionStore as PromotionStore;
    }

    get modalStore(): ModalStore {
        return this.props.ModalStore as ModalStore;
    }

    public action = async () => {
        const {promotion} = this.props;

        this.promotionStore.setSpinner(true);
        await this.promotionStore.deleteById(promotion.getId());
        const data = await this.promotionStore.getPaginate();

        this.promotionStore
            .setPages(data.pages)
            .setPromotions(data.data)
            .setSpinner(false);

        this.modalService.closeModal();
    };

    public render(): React.ReactNode {
        const {t} = this.props;

        return (
            <ConfirmationModal
                handleClose={this.modalService.closeModal}
                open={this.modalStore.getModal().getOpenModal()}
                action={this.action}
                spinner={this.promotionStore.getSpinner()}
                title={t("confirm.content")}
                content={t("confirm.title")}
            />
        );
    }
}

export default withNamespaces("modal")(DeletePromotionViewModel);
